import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    scarvesCount: 0,
    countryCount: 0,
    scarvesData: [],
    homeTopScroll: 0,
    contributorScarvesCount: {},
    contributorsList: {},
};

export const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setScarvesCount: (state, action) => {
            state.scarvesCount = action.payload;
        },
        setCountryCount: (state, action) => {
            state.countryCount = action.payload;
        },
        setScarvesData: (state, action) => {
            state.scarvesData = action.payload;
        },
        setHomeTopScroll: (state, action) => {
            state.homeTopScroll = action.payload;
        },
        setContributorScarvesCount: (state, action) => {
            state.contributorScarvesCount = action.payload;
        },
        setContributorsList: (state, action) => {
            state.contributorsList = action.payload;
        },
    },
});

export const {
    setCountryCount,
    setScarvesCount,
    setScarvesData,
    setHomeTopScroll,
    setContributorScarvesCount,
    setContributorsList,
} = dataSlice.actions;

export default dataSlice.reducer;
